// extracted by mini-css-extract-plugin
export default {"video-main_container":"VideoContainer_video-main_container__jlimd"};